module.exports = __webpack_public_path__ + "static/media/blockchain.4975fa91.png";